import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { combineLatest } from "rxjs";
import { first } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";
import { AccountInfoExtended } from "@ags/core";
import { ModuleService } from "../../shared/module.service";
import { AuthService } from "../../auth/auth.service";
import { LoadingScreenService } from "../../shared/loading-screen.service";
import { ApiService } from "./api.service";
import { DataService } from "./data.service";

@Injectable()
export abstract class BaseComponent implements OnDestroy, OnInit {
  private destroyed = false;
  public isLoadingFinished: boolean;
  public isAuthorizedUser = false;
  public userCanPslBuildout: boolean;
  public userCanOnDemandBuildout: boolean;
  public userCanViewStatus: boolean;
  protected user: AccountInfoExtended;
  protected userRights: string[] = [];

  protected constructor(
    private _moduleService: ModuleService,
    protected auth: AuthService,
    protected apiService: ApiService,
    public dataService: DataService,
    protected route: ActivatedRoute,
    protected loadingScreenService: LoadingScreenService
  ) {}

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  onGetRowHeight(params) {
    const defaultRowHeight = params.node.rowHeight;
    if (params.data.requestData) {
      return this.calcDetailRowsHeight(defaultRowHeight, params.data.requestData.length);
    } else {
      return defaultRowHeight; // default row hight
    }
  }

  calcDetailRowsHeight(rowHeight, numOfRows): number {
    const defaultRowHeight = rowHeight; // 28; //params.node.rowHeight;
    const defaultColumnHeight = defaultRowHeight * 1.2;
    const spareSpace = defaultRowHeight * 0.5;
    const detailRowsHeight = Math.max(2, numOfRows) * defaultRowHeight;
    return defaultRowHeight + detailRowsHeight + defaultColumnHeight + spareSpace;
  }

  isPrep(): boolean {
    return this._moduleService.module === "Billing Meter";
  }

  async loading(fn: (Function) => void) {
    this.loadingScreenService.setLoading(true);
    let finish = () => this.loadingScreenService.setLoading(false);
    await fn(finish);
  }

  async ngOnInit(): Promise<void> {
    if (await this.auth.isAuthenticated()) {
      this.isAuthorizedUser = true;
      this.user = await this.auth.getUser();
    }
    this.userCanPslBuildout = false;
    this.userCanOnDemandBuildout = false;
    this.userCanViewStatus = false;
    await this.loading((finish) => {
      combineLatest([this.apiService.CheckPermission(), this.route.queryParams])
        .pipe(first())
        .subscribe(
        async (ret) => {
          const [res, params] = ret;
          this.userRights = res as string[];
          if (this.userRights.includes("VIEW")) {
            this.userCanViewStatus = true;
          }
          if (this.userRights.includes("PSL")) {
            this.userCanPslBuildout = true;
          }
          if (this.userRights.includes("ONDEMAND")) {
            this.userCanOnDemandBuildout = true;
          }
          try {
            await this.dataService.Params(params["cloud"], params["region"]);
          } catch (e) {
            console.error(e);
          }
          await this.onInit();
          this.isLoadingFinished = true;
          finish();
        },
        async (_) => {
          this.isLoadingFinished = true;
          finish();
        }
      );
    });
  }

  abstract onInit();
}
